import {ActionHandlerBase} from "../action-handler-base";
import {IPerformActionTopicPayload} from "@sparkware/uc-sdk-core";

export class OpenWithdrawActionHandler extends ActionHandlerBase {
    async handle(payload: IPerformActionTopicPayload): Promise<void> {
        await this.services.cashier.openWithdraw({
            channel: payload.launchInfo?.channel,
            launchInfo: payload.launchInfo
        });
    }
}